var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"aam-auth-tg btn",on:{"click":_vm.tgGetAuthResponse}},[_c('img',{attrs:{"src":require("assets/img/svg/socials/telegram-auth.svg")}}),_vm._v("\n  Telegram\n")])}
var staticRenderFns = []

export { render, staticRenderFns }